if (!customElements.get('fnf-tabs')) {
  class FNFTabs extends HTMLElement {
    static get observedAttributes() {
      return ['active-index'];
    }
    constructor() {
      super();
      this.activeIndex = parseInt(this.getAttribute('active-index')) || 0;
      this.previousIndex = this.activeIndex;

      this.onWindowResize = this.onWindowResize.bind(this);
      this.onContentResize = this.onContentResize.bind(this);

      this.contentResizeObserver = new ResizeObserver(this.onContentResize);
    }
    attributeChangedCallback(name, _oldValue, newValue) {
      if (name === 'active-index') {
        this.activeIndex = parseInt(newValue);
        if (this.tabButtons) this.updateActiveTab();
      }
    }
    render() {
      const tabs = Array.from(this.querySelectorAll('fnf-tab'));
      const tabsData = tabs.map((tab, i) => {
        return {
          label: tab.getAttribute('label') || `Tab ${i + 1}`,
          content: tab.innerHTML,
        };
      });

      // Clear existing content
      this.innerHTML = ``;

      const tabsContainer = document.createElement('div');
      tabsContainer.classList.add('tabs-container');

      const tabsContent = document.createElement('div');
      tabsContent.classList.add('tabs-content-container');
      tabsContent.setAttribute('role', 'tabpanel');

      if (tabsData.length > 1) {
        const tabsHeader = document.createElement('div');
        tabsHeader.classList.add('tabs-header');
        tabsHeader.setAttribute('role', 'tablist');

        tabsData.forEach((tab, i) => {
          const { label } = tab;

          const tabButton = document.createElement('button');
          tabButton.textContent = label;
          tabButton.classList.add('tabs-button');
          tabButton.dataset.index = i;
          tabButton.setAttribute('aria-controls', `tab-${i}`);
          tabButton.setAttribute('role', 'tab');

          tabsHeader.appendChild(tabButton);
        });

        tabsContainer.appendChild(tabsHeader);

        this.tabButtons = tabsHeader.querySelectorAll('.tabs-button');

        this.tabButtons.forEach((button) => {
          button.addEventListener('click', (event) => { // Add event parameter
            event.preventDefault(); // Prevent default button behavior
            const index = parseInt(button.dataset.index);
            // Only set attribute if clicking a different tab
            if (index !== this.activeIndex) {
              this.setAttribute('active-index', index);
            }
          });
        });
      } else {
        this.tabButtons = null;
      }

      tabsData.forEach((tab, i) => {
        const { content } = tab;

        const tabContent = document.createElement('div');
        tabContent.classList.add('tabs-content');
        tabContent.innerHTML = content;
        tabContent.id = `tab-${i}`;
        tabContent.setAttribute('role', 'tabpanel');
        tabContent.setAttribute('aria-labelledby', `tab-${i}`);

        tabsContent.appendChild(tabContent);
      });

      tabsContainer.appendChild(tabsContent);

      this.appendChild(tabsContainer);

      this.tabContents = tabsContent.querySelectorAll('.tabs-content');

      this.updateActiveTab();
    }
    updateActiveTab() {
      if (!this.tabContents) return;

      const index = this.activeIndex;
      const direction = index > this.previousIndex ? 'next' : 'prev';
      const hasSingleTab = !this.tabButtons;

      if (this.tabButtons) {
        this.tabButtons.forEach((button, i) => {
          button.classList.toggle('active', i === index);
        });
      }

      const currentContent = this.tabContents[this.previousIndex];
      const nextContent = this.tabContents[index];

      if (!hasSingleTab) {
        // Remove any existing animation classes
        this.tabContents.forEach(content => {
          content.classList.remove('animate-in-next', 'animate-in-prev', 'animate-out-next', 'animate-out-prev');
        });

        // Add animation classes
        currentContent.classList.add(`animate-out-${direction}`);
        nextContent.classList.add(`animate-in-${direction}`);
      }

      // Set active states
      currentContent.classList.remove('active');
      nextContent.classList.add('active');

      this.previousIndex = index;

      if (this.currentContentElement) {
        this.contentResizeObserver.unobserve(this.currentContentElement);
      }

      this.currentContentElement = nextContent;
      this.contentResizeObserver.observe(this.currentContentElement);
      this.onContentResize();

      if (!hasSingleTab) {
        // Clean up animation classes after animation completes
        setTimeout(() => {
          currentContent.classList.remove(`animate-out-${direction}`);
          nextContent.classList.remove(`animate-in-${direction}`);
        }, 200); // Match this with CSS animation duration
      }
    }
    onWindowResize() {
      this.onContentResize();
    }
    onContentResize(entries) {
      let contentHeight;

      if (entries && entries.length > 0) {
        contentHeight = entries[0].contentRect.height;
      } else if (this.currentContentElement) {
        contentHeight = this.currentContentElement.getBoundingClientRect().height;
      } else {
        return;
      }

      this.style.setProperty('--content-height', `${contentHeight}px`);
    }
    connectedCallback() {
      this.render();
      window.addEventListener('resize', this.onWindowResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onWindowResize);
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
      }
    }
  }

  class FNFTab extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  }
  customElements.define('fnf-tabs', FNFTabs);
  customElements.define('fnf-tab', FNFTab);
}
